import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const PROJECTUNITDETAILS_LIST = "projectunitdetails_list";
export const CREATE_PROJECTUNITDETAILS = "create_projectunitdetails";
export const UPDATE_PROJECTUNITDETAILS = "update_projectunitdetails";
export const DELETE_PROJECTUNITDETAILS = "delete_projectunitdetails";
export const GET_PROJECTUNITDETAILS_DETAILS = "get_projectunitdetails_details";
export const GET_PROJECTUNITDETAILS_DETAILS_BY_UNIT_NUMBER = "get_projectunitdetails_details_by_unit_number";
export const PROJECTUNITDETAILS_SIMPLE_LIST = "projectunitdetails_simple_details";
export const CLEAR_PROJECTUNITDETAILS_ERRORS = "clearProjectUnitDetailsErrors";

// mutation types
export const SET_PROJECTUNITDETAILS_ERROR = "setProjectUnitDetailsErrors";
export const REMOVE_PROJECTUNITDETAILS_ERRORS = "removeProjectUnitDetailsErrors";

const state = {
    errors: null,
    yearlyServiceCharges: '',
    monthlyCoolingCharges: ''
};
const actions = {
    [PROJECTUNITDETAILS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/projectunitdetails?project_id=" + payload.project_id + '&' + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_PROJECTUNITDETAILS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_PROJECTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [CREATE_PROJECTUNITDETAILS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createprojectunitdetail", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_PROJECTUNITDETAILS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_PROJECTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [UPDATE_PROJECTUNITDETAILS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updateprojectunitdetail", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_PROJECTUNITDETAILS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_PROJECTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [DELETE_PROJECTUNITDETAILS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deleteprojectunitdetail", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_PROJECTUNITDETAILS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_PROJECTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [GET_PROJECTUNITDETAILS_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getprojectunitdetaildetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_PROJECTUNITDETAILS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_PROJECTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [GET_PROJECTUNITDETAILS_DETAILS_BY_UNIT_NUMBER](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/getprojectunitdetaildetailbyunitnumber?project_id=" + payload.project_id + "&unit_no=" + payload.unit_no)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_PROJECTUNITDETAILS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_PROJECTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [CLEAR_PROJECTUNITDETAILS_ERRORS](context) {
        context.commit(REMOVE_PROJECTUNITDETAILS_ERRORS);
    },
    [PROJECTUNITDETAILS_SIMPLE_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/projectunitdetailssimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
};

const mutations = {
    [SET_PROJECTUNITDETAILS_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_PROJECTUNITDETAILS_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
